module.exports = __webpack_public_path__ + "img/icon-tag-doctor.cb15c06.svg";